export default "__VITE_ASSET__4bbf005a__"